import { call, cancelled, put, takeLatest } from 'redux-saga/effects';
import { apiRequest, setToken } from '../../../../utils/request';
import { accountSettingsActions as actions } from './';

function* changePassword(action: {
  type: string;
  payload: {
    old_password: string;
    new_password: string;
    password_confirmation: string;
  };
}) {
  try {
    const { old_password, new_password, password_confirmation } =
      action.payload;
    const payload = yield call(apiRequest, {
      url: 'users/change-password',
      method: 'put',
      data: {
        old_password,
        new_password,
        password_confirmation,
      },
    });
    if (payload.token) {
      yield call(setToken, payload.token);
    }

    yield put(actions.changePasswordSuccess(payload));
  } catch (error) {
    // @ts-ignore
    yield put(actions.changePasswordFailed(error.payload));
  } finally {
    if (yield cancelled()) {
    }
  }
}

function* reset2fa(action: { type: string }) {
  try {
    const payload = yield call(apiRequest, {
      url: 'users/reset-2fa',
      method: 'put',
    });
    yield put(actions.reset2faSuccess(payload));
  } catch (error) {
    // @ts-ignore
    yield put(actions.reset2faFailed(error.payload));
  } finally {
    if (yield cancelled()) {
    }
  }
}

export function* accountSettingsSaga() {
  yield takeLatest(actions.changePasswordRequest.type, changePassword);
  yield takeLatest(actions.reset2faRequest.type, reset2fa);
}
